import "./svg/nav-home.svg"

export default {
    name: "nav-home",
    viewBox: "24 24",
}
